export const validateEmail = (value, ifNotRequired = true) => {
    if (!value && ifNotRequired) {
        return true;
    }
    return value &&
        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(value)
        ? 'email-address-not-valid'
        : undefined;
};
